import React from 'react';
import Reflux from 'reflux';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { OrderedMap, Map } from 'immutable';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import CuesheetColumnActions from 'shared/flux/actions/cuesheet/CuesheetColumnActions';
import PureRenderMixin from 'react-pure-render/mixin';
import ColumnMenuMixin from 'main/components/show/cuesheet/columnHeaderCell/columnMenuMixin';
import GridColumnMenuHelper from 'main/components/show/grid/columnHeaderCell/columnMenuHelper';
import ConfirmActions from 'flux/actions/ConfirmActions';
import keyIn from 'shared/lib/immutable/keyIn';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import role from 'shared/lib/role';
import KeyModifierConstants from 'shared/constants/KeyModifierConstants.jsx';
import { ColumnWidthStrings } from 'flux/stores/cuesheet/CuesheetConstants';
import { isMac } from 'shared/lib/platformCheck';

export default React.createClass({
  displayName: 'ColumnMenu',

  mixins: [
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    PureRenderMixin,
    ColumnMenuMixin,
    Reflux.connectFilter(CuesheetStore, 'userSettings', (st) =>
      st.get('userSettings'),
    ),
    Reflux.connectFilter(CuesheetStore, 'showSettings', (st) => {
      if (!st.get('show')) return null;
      return st
        .get('show')
        .filter(
          keyIn(
            'displayType',
            'displayItemNumbers',
            'displayStartTime',
            'displayDuration',
            'displayPresetDuration',
            'displayItemTitles',
            'displayItemDescriptions',
          ),
        );
    }),
    Reflux.connect(UserSessionStore, 'user'),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const { hide } = this.props;

    if (!this.state.showSettings || hide) return <span />;

    const showMenu = this.state.popoverVisibility.get(
      this.props.column.get('_id'),
    );

    return (
      <PopoverMenu
        grid
        className="grid-data-column-menu"
        config={this._getConfigData()}
        show={showMenu}
      />
    );
  },

  _getConfigData() {
    let id = this._getColumnId();

    let { teamId, eventId } = this.context.router.state.params;
    let hasEventAdmin = role.hasEventAdminRole(
      this.state.user,
      teamId,
      eventId,
    );

    let items = OrderedMap({
      hideColumn: Map({
        content: (
          <span>
            {this._getMenuItemNode('eye-slash', 'Hide Column')}
            {this._getKeyModifier('hideColumn')}
          </span>
        ),
        onClick: () => this._handleHideColumnClick(),
      }),
      showAllColumns: Map({
        divider: true,
        content: (
          <span>
            {this._getMenuItemNode('eye', 'Show All Columns')}
            {this._getKeyModifier('showAllColumns')}
          </span>
        ),
        onClick: () => this._handleShowAllColumnsClick(),
      }),
      moveUserColumnLeft: Map({
        hidden: !hasEventAdmin,
        content: (
          <span>
            {this._getMenuItemNode('arrow-circle-left', 'Move Column Left')}
            {this._getKeyModifier('moveColumnLeft')}
          </span>
        ),
        onClick: () => this._handleMoveColumnLeftClick(),
      }),
      moveUserColumnRight: Map({
        hidden: !hasEventAdmin,
        divider: true,
        content: (
          <span>
            {this._getMenuItemNode('arrow-circle-right', 'Move Column Right')}
            {this._getKeyModifier('moveColumnRight')}
          </span>
        ),
        onClick: () => this._handleMoveColumnRightClick(),
      }),
      setWidthUltraNarrow: Map({
        hidden: !hasEventAdmin,
        content: this._getMenuWidthItemNode('Ultra Narrow'),
        onClick: () =>
          this._handleSetColumnWidthClick(ColumnWidthStrings.UltraNarrow),
      }),
      setWidthNarrow: Map({
        hidden: !hasEventAdmin,
        content: (
          <span>
            {this._getKeyModifier('widthShrink')}
            {this._getMenuWidthItemNode('Narrow')}
          </span>
        ),
        onClick: () =>
          this._handleSetColumnWidthClick(ColumnWidthStrings.Narrow),
      }),
      setWidthNormal: Map({
        hidden: !hasEventAdmin,
        content: (
          <span>
            {this._getKeyModifier('widthShrink')}
            {this._getMenuWidthItemNode('Normal')}
          </span>
        ),
        onClick: () =>
          this._handleSetColumnWidthClick(ColumnWidthStrings.Normal),
      }),
      setWidthWide: Map({
        hidden: !hasEventAdmin,
        content: (
          <span>
            {this._getKeyModifier('widthGrow')}
            {this._getMenuWidthItemNode('Wide')}
          </span>
        ),
        onClick: () => this._handleSetColumnWidthClick(ColumnWidthStrings.Wide),
      }),
      setWidthScriptWide: Map({
        hidden: !hasEventAdmin,
        divider: true,
        content: (
          <span>
            {this._getKeyModifier('widthGrow')}
            {this._getMenuWidthItemNode('Script Wide')}
          </span>
        ),
        onClick: () =>
          this._handleSetColumnWidthClick(ColumnWidthStrings.ScriptWide),
      }),
      addColumnToEnd: Map({
        hidden: !hasEventAdmin,
        divider: true,
        content: this._getMenuItemNode('plus-circle', 'Add Column To End'),
        onClick: () => this._handleAddColumnToEndClick(),
      }),
      deleteItem: Map({
        hidden: !hasEventAdmin,
        content: this._getMenuItemNode('trash', 'Delete Column'),
        onClick: () => this._handleDeleteColumnClick(),
      }),
    })
      .merge(
        GridColumnMenuHelper.getUtilityColumnOptions(
          this.context,
          this.state,
          false,
          this.props.user,
        ),
      )
      .filter((item) => item.get('hidden') !== true);

    return Map({
      id,
      noCaret: false,
      icon: 'angle-down',
      placement: 'bottom',
      onClick: () => PopoverActions.show(id),
      onHide: () => PopoverActions.hide(id),
      items,
    });
  },

  _getKeyModifier(type) {
    let command = isMac()
      ? KeyModifierConstants.macKeys[type]
      : KeyModifierConstants.windowsKeys[type];

    return <span className="shortcut-key-modifier">{command}</span>;
  },

  _getMenuItemNode(icon, label) {
    return (
      <span className="grid-column-menu">
        <Icon name={icon} />
        <span>{label}</span>
      </span>
    );
  },

  _getMenuWidthItemNode(width) {
    let column = this.props.column;

    let checked =
      column.get('width').toLowerCase() ===
      width.toLowerCase().replace(/ /g, '');
    return (
      <span className="grid-column-menu grid-column-menu-width">
        {this.getRadioWithLabelNode(checked, `Set Width ${width}`)}
      </span>
    );
  },

  _getColumnId() {
    return this.props.column.get('_id');
  },

  _handleHideColumnClick() {
    CuesheetColumnActions.hideColumn(this._getColumnId());
  },

  _handleShowAllColumnsClick() {
    CuesheetColumnActions.showColumns();
  },

  _handleMoveColumnLeftClick() {
    CuesheetColumnActions.moveColumnLeft(this._getColumnId());
  },

  _handleMoveColumnRightClick() {
    CuesheetColumnActions.moveColumnRight(this._getColumnId());
  },

  _handleAddColumnToEndClick() {
    CuesheetColumnActions.addColumn();
  },

  _handleDeleteColumnClick() {
    let confirmAction = () =>
      CuesheetColumnActions.deleteColumn(this._getColumnId());
    let confirmQuestion =
      'Are you sure you want to delete column ' +
      this.props.column.get('title') +
      '?';
    ConfirmActions.prompt(confirmQuestion, confirmAction);
  },

  _handleSetColumnWidthClick(width) {
    CuesheetColumnActions.updateColumnWidth(this._getColumnId(), width);
  },
});
